import React from 'react'

function AdminNotificaciones() {
  return (
    <div>
      <h2>Favoritos del Administrador</h2>
    </div>
  )
}

export default AdminNotificaciones
